import { LoaderCircle } from "lucide-react";
import { Icon } from "../Icon/Icon";
import { cn } from "../../lib/cn";

interface SpinnerProps {
  size?: "sm" | "base" | "lg";
  // Accessible name for the loading state — there's no visible text for a
  // bare spinner to point to, so this goes straight on role="status" (same
  // precedent AlertBanner's bare role="status" sets, see its own file).
  label?: string;
  className?: string;
}

// For small, already-fixed-size loading spots only (e.g. inline next to text
// where the surrounding layout doesn't depend on this component's size) —
// prefer Skeleton for anything that should reserve the shape of real content,
// see docs/design-system.md's "Loading states" section.
export function Spinner({ size, label = "Loading", className = "" }: SpinnerProps) {
  return (
    <span role="status" aria-label={label} className="inline-flex">
      <Icon
        icon={LoaderCircle}
        size={size}
        aria-hidden="true"
        className={cn("animate-spin motion-reduce:animate-none text-accent-600", className)}
      />
    </span>
  );
}
